import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { Button } from 'foundations-components/transitional/components/Button';
import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { WHATSAPP_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import DisabledAlertBase from './DisabledAlertBase';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getAlertMessage = genericChannelId => {
  switch (genericChannelId) {
    case WHATSAPP_GENERIC_CHANNEL_ID:
      {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "strong",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "composer-ui.capability-editor.disabled-editor.whatsapp.none.emphasizedText"
            })
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.capability-editor.disabled-editor.whatsapp.none.description"
          })]
        });
      }
    default:
      {
        return null;
      }
  }
};
const DisabledAlertUpgradeRequired = ({
  message
}) => {
  const genericChannelId = getGenericChannelId(message);
  const upgradeLink = `${getFullUrl('app')}/pricing/${PortalIdParser.get()}`;
  return /*#__PURE__*/_jsx(DisabledAlertBase, {
    message: getAlertMessage(genericChannelId),
    type: 'danger',
    button: /*#__PURE__*/_jsx(Button, {
      use: "tertiary",
      size: "extra-small",
      external: true,
      href: upgradeLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.capability-editor.disabled-editor.upgrade"
      })
    })
  });
};
DisabledAlertUpgradeRequired.displayName = 'DisabledAlertUpgradeRequired';
export default DisabledAlertUpgradeRequired;